import type React from "react"

import Box from "@mui/material/Box"

interface IfProps {
  children: React.ReactNode
  condition: unknown
  keepMounted?: boolean
}

/**
 * A component that conditionally displays its children
 *
 * @param props The component properties
 * @param props.children The child nodes to render
 * @param props.condition The condition that determines if the children are rendered
 * @param props.keepMounted If true, the children will be kept mounted but hidden when the condition is false.
 * @example
 * return (
 *   <If condition={hasPermission}>
 *     <ManageUsers />
 *   </If>
 * )
 */
export const If = ({ children, condition, keepMounted }: IfProps) => {
  const shouldShow = Boolean(condition)

  if (keepMounted) {
    return (
      <Box sx={shouldShow ? undefined : { display: "none" }}>{children}</Box>
    )
  }

  return <>{shouldShow && children}</>
}
